import { useEffect, useState } from 'react'

// A time window is only evaluated when something renders, so without this a page with no traffic
// keeps displaying figures long after they should have aged out. Paused while hidden, and re-read
// on becoming visible so a returning tab is correct at once.
export const useRefreshingNow = (intervalMs: number): number => {
	const [now, setNow] = useState(() => Date.now())

	useEffect(() => {
		let timer: ReturnType<typeof setInterval> | undefined
		const refresh = () => setNow(Date.now())

		const start = () => {
			if (timer === undefined) {
				timer = setInterval(refresh, intervalMs)
			}
		}

		const stop = () => {
			if (timer !== undefined) {
				clearInterval(timer)
				timer = undefined
			}
		}

		const handleVisibility = () => {
			if (document.visibilityState === 'visible') {
				refresh()
				start()
			} else {
				stop()
			}
		}

		if (document.visibilityState === 'visible') {
			start()
		}
		document.addEventListener('visibilitychange', handleVisibility)

		return () => {
			stop()
			document.removeEventListener('visibilitychange', handleVisibility)
		}
	}, [intervalMs])

	return now
}
